import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKodemDark = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#a)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M11.518.482a2 2 0 0 1 2 2v9.036a2 2 0 0 1-2 2H2.482a2 2 0 0 1-2-2V2.482a2 2 0 0 1 2-2h9.036ZM3.41 3.146v7.716H5.29V3.146H3.411Zm5.041-.008L5.986 7l2.466 3.862h2.111L8.096 7l2.467-3.862h-2.11Z",
				fill: "#595959"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "a",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M0 0h14v14H0z"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgKodemDark);
export { ForwardRef as ReactComponent };
